export const reportsPage = {
  aiSearchFeedback: {
    pageTitle: 'AI Search Feedback',
    sectionTitle: 'Feedback',
    filters: {
      dateRange: 'Date range',
      rating: 'Rating'
    },
    ratings: {
      all: 'All',
      up: 'Thumbs up',
      down: 'Thumbs down'
    },
    columns: {
      date: 'Date',
      practice: 'Practice',
      admin: 'Admin',
      rating: 'Rating',
      comment: 'Comment',
      question: 'Question'
    }
  },
  ccmReports: {
    scheduledSuccessMessage: 'CCM Detailed Patient Report scheduled successfully',
    scheduleFailedMessage: 'Failed to schedule CCM Detailed Patient Report'
  },
  payerChartRequests: {
    pageTitle: 'Payer Chart Requests',
    sectionTitle: 'Requests',
    newRequestButtonLabel: 'New Request',
    newRequestTitle: 'New Payer Chart Request',
    downloadZipTooltip: 'Download Zip',
    failedStatusLabel: 'Failed',
    columns: {
      requestName: 'Request Name',
      insurance: 'Insurance',
      requestedBy: 'Requested By',
      status: 'Status',
      downloadZip: 'Download Zip'
    },
    preview: {
      matchingStarting: 'Matching patients…',
      matchingProgress: (done: number, total: number) => `Matching patients… ${done} of ${total}`,
      retryRemainingButton: 'Retry remaining',
      readFailed: 'Could not read the CSV file.',
      errors: {
        timeout: (from: number, to: number, done: number, total: number | null) =>
          total === null
            ? `Matching timed out on patients ${from}–${to}. Click Retry remaining to continue.`
            : `Matching timed out on patients ${from}–${to} (${done} of ${total} matched). Click Retry remaining to continue.`,
        network: (from: number, to: number) =>
          `Could not reach the server while matching patients ${from}–${to}. Check your connection, then click Retry remaining.`,
        server: (from: number, to: number) =>
          `Something went wrong while matching patients ${from}–${to}. Click Retry remaining. If it keeps failing, contact support with the time of this upload.`
      },
      summary: {
        total: (count: number) => `Total ${count}`,
        matched: (count: number) => `Matched ${count}`,
        multiple: (count: number) => `Multiple ${count}`,
        unmatched: (count: number) => `Unmatched ${count}`,
        invalid: (count: number) => `Invalid ${count}`
      }
    }
  },
  rpmCompanies: {
    scheduledSuccessMessage: 'RPM Performance Report scheduled successfully',
    scheduleFailedMessage: 'Failed to schedule RPM Performance Report',
    confirmScheduleTitle: 'Confirm Schedule Report'
  },
  runReportsLabel: 'Run Reports',
  rpmProviders: {
    fetchErrorMessage: 'Failed to retrieve data',
    columns: {
      monthYear: 'Month Year',
      providerName: 'Provider Name',
      reportsReviewed: 'No. of RPM Reports Reviewed',
      patientsSignedOff: 'No. of RPM Patients Signed Off',
      patientsApprovedRejectedIncomplete: 'No. of RPM Patients Approved, Rejected, Incomplete (Total)'
    }
  },
  rpmMetrics: {
    primaryMetricsTitle: 'Primary Metrics',
    comparisonMetricsTitle: 'Comparison Metrics'
  },
  rpmProviderSignoffs: {
    initialVisitOption: 'New Patient Visit',
    followUpOption: 'Follow-up',
    ccmOnboardingsOption: 'CCM Evaluations',
    columns: {
      providerFirstName: 'Provider First Name',
      providerLastName: 'Provider Last Name',
      signOffDate: 'Sign-Off Date',
      totalSignOffs: 'Total Sign-Offs',
      encounterType: 'Encounter Type',
      encounterMode: 'Encounter Mode'
    },
    signedOffMonthLabel: 'Signed-Off Month'
  },
  encounters: {
    columns: {
      patient: 'Patient',
      title: 'Title',
      calledBy: 'Called By',
      originatingClientOrg: 'Originating Client Org',
      originatingClientStore: 'Originating Client Store',
      calledOn: 'Called On'
    },
    organizationLabel: 'Organization',
    selectOptionPlaceholder: 'Select an option...',
    locationLabel: 'Location',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date'
  },
  rpmAllChartReviews: {
    csvHeaders: {
      patientName: 'Patient Name',
      reportMonthYear: 'Report Month Year',
      providerName: 'Provider Name',
      signedOffAt: 'Signed-Off At',
      companyName: 'Pharmacy Name',
      numCriticalAlerts: 'Num of Critical Alerts'
    },
    columns: {
      patientName: 'Patient Name',
      reportMonthYear: 'Report Month Year',
      providerName: 'Provider Name',
      signedOffAt: 'Signed-Off At',
      activityTime: 'Activity Time (HH:mm:ss)',
      companyName: 'Pharmacy Name',
      numCriticalAlerts: 'Num of Critical Alerts'
    },
    signedOffMonthLabel: 'Signed-Off Month'
  },
  performance: {
    fetchErrorMessage: 'Failed to retrieve reports',
    csvHeaders: {
      date: 'Date',
      user: 'User',
      activeTime: 'Active Time',
      billed: 'Billed ($)',
      bonus: 'Bonus ($)',
      numEncounters: 'No of Encounters',
      invoiceTime: 'Invoice Time',
      invoiceAmount: 'Invoice Amount'
    },
    columns: {
      date: 'Date',
      user: 'User',
      activeTime: 'Active Time',
      billedAmount: 'Billed Amount',
      bonusAmount: 'Bonus Amount',
      numOfEncounters: 'Num Of Encounters',
      invoicedTime: 'Invoiced Time',
      invoicedAmount: 'Invoiced Amount'
    },
    dashboardTabLabel: 'Dashboard',
    detailedPerformanceTabLabel: 'Detailed Performance',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    allOption: 'All',
    allGroupedOption: 'All Grouped',
    tasksPerformanceTabLabel: 'Tasks Performance'
  },
  workqueue: {
    allProvidersOption: 'All Providers',
    myPatientsOption: 'My Patients',
    completeLabel: 'Complete',
    incompleteLabel: 'Incomplete',
    rpmChip: 'RPM',
    ccmChip: 'CCM',
    workqueueLabel: 'Workqueue',
    selectWorkqueuePlaceholder: 'Select Workqueue',
    legacyCcmNotesOption: 'Legacy CCM Notes',
    pharmacyLabel: 'Pharmacy',
    selectPharmacyPlaceholder: 'Select Pharmacy',
    renderingProviderLabel: 'Rendering Provider',
    selectProviderPlaceholder: 'Select Provider',
    signOffStartLabel: 'Sign-off Start',
    signOffEndLabel: 'Sign-off End',
    hideCompletedLabel: 'Hide completed',
    columns: {
      workqueueStatus: 'Workqueue Status',
      patientName: 'Patient Name',
      pharmacy: 'Pharmacy',
      visitType: 'Visit Type',
      signedOffAt: 'Signed Off At',
      lastAmended: 'Last Amended',
      rpmEnrolled: 'RPM Enrolled',
      ccmEnrolled: 'CCM Enrolled',
      currentEnrolledPrograms: 'Current Enrolled Programs',
      noteFormat: 'Note Format',
      provider: 'Provider',
      amendingProvider: 'Amending Provider'
    }
  },
  billing: {
    fetchErrorMessage: 'Failed to retrieve tasks',
    csvHeaders: {
      name: 'Name',
      type: 'Type',
      mtmNumber: 'MTM Number',
      status: 'Status',
      billed: 'Billed ($)',
      bonus: 'Bonus ($)',
      resolution: 'Resolution',
      wrapUpStatus: 'Wrap Up Status',
      performedBy: 'Performed By',
      performedOn: 'Performed On',
      organization: 'Organization',
      location: 'Location',
      originatingClientOrganization: 'Originating Client Organization',
      originatingClientLocation: 'Originating Client Location'
    },
    columns: {
      name: 'Name',
      type: 'Type',
      status: 'Status',
      billed: 'Billed',
      bonus: 'Bonus',
      resolution: 'Resolution',
      wrapUpStatus: 'Wrap Up Status',
      performedBy: 'Performed By',
      performedOn: 'Performed On',
      organization: 'Organization',
      location: 'Location'
    },
    billingDetailsTabLabel: 'Billing Details'
  },
  userSessionTime: {
    columns: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      title: 'Title',
      totalSessionTime: 'Total Session Time (H:M:S)',
      totalEnteredCareActivityTime: 'Total Entered Care Activity Time (H:M:S)',
      actions: 'Actions'
    },
    viewInDetailsTooltip: 'View In Details',
    selectDateRangeLabel: 'Select Date Range',
    csvHeaders1: {
      no: 'No',
      pharmacistName: 'Pharmacist Name',
      pharmacistEmail: 'Pharmacist Email',
      pharmacistTitle: 'Pharmacist Title',
      patientId: 'Patient ID',
      patientName: 'Patient Name',
      pharmacistTotalTimeHms: 'Pharmacist Total Time (H:M:S)',
      pharmacistTotalTimeSeconds: 'Pharmacist Total Time (In Seconds)',
      patientTotalTimeHms: 'Patient Total Time (H:M:S)',
      patientTotalTimeSeconds: 'Patient Total Time (In Seconds)',
      activity: 'Activity',
      activityTimeSeconds: 'Activity Time (In Seconds)',
      activityStartDate: 'Activity Start Date',
      activityEndDate: 'Activity End Date'
    },
    csvHeaders2: {
      no: 'No',
      activityMonth: 'Activity Month',
      firstName: 'First Name',
      lastName: 'Last Name',
      pharmacyName: 'Pharmacy Name',
      type: 'Type',
      category: 'Category',
      careTimeSeconds: 'Care Time (In Seconds)',
      careTimeHms: 'Care Time (H:M:S)',
      totalCareActivityTimeSeconds: 'Total Care Activity Time (In Seconds)',
      totalCareActivityTimeHms: 'Total Care Activity Time (H:M:S)'
    }
  },
  reportDashboard: {
    totalPatientsLabel: 'Total # of Patients',
    totalImportsLabel: 'Total # of Imports',
    totalMedsImportedLabel: 'Total # of Meds Imported',
    totalMedsPostCmrLabel: 'Total # of Meds Post-CMR',
    avgPatientAgeLabel: 'Average Patient Age',
    avgMedsPerPatientLabel: 'Average # Meds / Patient',
    tbdLabel: 'TBD',
    yearLabel: 'Year',
    monthsLabel: 'Months',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    tableAriaLabel: 'simple table'
  },
  billingDetailsFilter: {
    confirmScheduleTitle: 'Confirm Schedule Report',
    scheduleSuccessMessage: 'Report scheduled successfully',
    scheduleFailedMessage: 'Failed to schedule report',
    scheduledReportsTitle: 'Scheduled Reports',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date'
  },
  billingStat: {
    totalBilledAmountTitle: 'Total Billed Amount',
    totalBonusAmountTitle: 'Total Bonus Amount'
  },
  taskPerformance: {
    noDataFoundMessage: 'No data found for the selected criteria',
    fetchErrorMessage: 'Failed to load performance reports',
    exportLoadedMessage: 'Export data loaded successfully!',
    noExportDataMessage: 'No data available for export',
    exportFailedMessage: 'Failed to load export data',
    columns: {
      patientName: 'Patient Name',
      birthday: 'Birthday',
      type: 'Type',
      status: 'Status',
      billed: 'Billed ($)',
      bonus: 'Bonus ($)',
      resolution: 'Resolution',
      wrapUpStatus: 'Wrap Up Status',
      performedOn: 'Performed On',
      organization: 'Organization',
      location: 'Location',
      originatedClientOrg: 'Originated Client Org',
      originatedClientLocation: 'Originated Client Location'
    },
    csvHeaders: {
      patientName: 'Patient Name',
      mtmNumber: 'MTM Number',
      birthday: 'Birthday',
      type: 'Type',
      status: 'Status',
      billed: 'Billed ($)',
      bonus: 'Bonus ($)',
      resolution: 'Resolution',
      wrapUpStatus: 'Wrap Up Status',
      performedOn: 'Performed On',
      organization: 'Organization',
      location: 'Location',
      originatedClientOrg: 'Originated Client Org',
      originatedClientLocation: 'Originated Client Location'
    },
    userAndDateRequiredMessage: 'Please ensure user and date are selected',
    userRequiredMessage: 'Please select a user',
    dateRequiredMessage: 'Please select a report date',
    reportDateLabel: 'Report Date',
    userLabel: 'User',
    selectUserPlaceholder: 'Select User'
  },
  filterSection: {
    filtersTitle: 'Filters',
    selectOrganizationLabel: 'Select Organization',
    selectOptionPlaceholder: 'Select an option...',
    dateRangeLabel: 'Date Range',
    comparisonDateRangeTitle: 'Comparison Date Range',
    compareDateRangeLabel: 'Compare Date Range',
    currentPeriodTitle: 'Current Period',
    comparePeriodTitle: 'Compare Period'
  },
  metricsGrid: {
    totalAlertsTitle: 'Total Alerts',
    totalAlertsSubText: 'All Device Alerts',
    criticalHighTitle: 'Critical High',
    criticalHighSubText: 'Critical High Alerts',
    criticalLowTitle: 'Critical Low',
    criticalLowSubText: 'Critical Low Alerts',
    criticalChipLabel: 'Critical',
    highTitle: 'High',
    highSubText: 'High Alerts',
    lowTitle: 'Low',
    lowSubText: 'Low Alerts',
    warningChipLabel: 'Warning',
    medRegimenTitle: 'Med Regimen',
    medRegimenSubText: 'Medication Regimen Alerts',
    enrollmentSummaryTitle: 'Enrollment Summary',
    enrollmentSummarySubText: 'Patient Enrollment Breakdown',
    totalEnrolledLabel: 'Total Enrolled',
    bpEnrolledLabel: 'BP Enrolled',
    bgEnrolledLabel: 'BG Enrolled',
    unenrolledTitle: 'Unenrolled',
    unenrolledSubText: 'Total Patients Unenrolled',
    totalFollowUpTasksTitle: 'Total Follow-up Tasks',
    totalFollowUpTasksSubText: 'Total Follow-up Tasks Created',
    pendingFollowUpsTasksTitle: 'Pending Follow-ups Tasks',
    pendingFollowUpsTasksSubText: 'Total Pending Follow-up Tasks',
    resolvedFollowUpsTasksTitle: 'Resolved Follow-ups Tasks',
    resolvedFollowUpsTasksSubText: 'Resolved Follow-up Tasks',
    pendingPercentTitle: 'Pending %',
    pendingPercentSubText: 'Pending Follow-up Tasks Percentage',
    readingsVarianceTitle: 'Readings Variance',
    readingsVarianceSubText: 'Variance in Patient Readings',
    withReadingLabel: 'With Reading',
    withoutReadingLabel: 'Without Reading',
    over16ReadingsTitle: '16+ Readings',
    over16ReadingsSubText: 'Patients With 16+ Readings',
    readings815Title: '8-15 Readings',
    readings815SubText: 'Patients With 8-15 Readings',
    readings17Title: '1-7 Readings',
    readings17SubText: 'Patients With 1-7 Readings',
    readings0Title: '0 Readings',
    readings0SubText: 'Patients With 0 Readings',
    complianceTitle: 'Compliance',
    complianceSubText: 'Reading Compliance',
    totalTimeSpentTitle: 'Total Time Spent (Hours)',
    totalTimeSpentSubText: 'Total Time Spent by Pharmacists',
    over60MinTitle: '60+ Minutes',
    over60MinSubText: 'Patients Exceeding 60 Minutes',
    between4060MinTitle: '40-60 Minutes',
    between4060MinSubText: 'Patients Between 40-60 Minutes',
    between2040MinTitle: '20-40 Minutes',
    between2040MinSubText: 'Patients Between 20-40 Minutes',
    under20MinTitle: '< 20 Minutes',
    under20MinSubText: 'Patients Less Than 20 Minutes',
    noTimeSpentTitle: 'No Time Spent',
    noTimeSpentSubText: 'Patients With No Time Spent'
  }
} as const;
